const TOUR_KEY_PREFIX = 'archon.tour.completed.';

export function buildTourStorageKey(tourId, tenantId, userId) {
  const tenant = tenantId || 'unknown';
  const user = userId != null ? String(userId) : 'unknown';
  return `${TOUR_KEY_PREFIX}${tourId}.${tenant}.${user}`;
}

export function isTourCompletedInStorage(tourId, tenantId, userId) {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(buildTourStorageKey(tourId, tenantId, userId)) === '1';
  } catch {
    return false;
  }
}

export function markTourCompletedInStorage(tourId, tenantId, userId) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(buildTourStorageKey(tourId, tenantId, userId), '1');
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearAllTourCompletionFlags() {
  if (typeof window === 'undefined') return;
  try {
    const keys = [];
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith(TOUR_KEY_PREFIX)) {
        keys.push(key);
      }
    }
    keys.forEach((key) => window.localStorage.removeItem(key));
  } catch {
    /* ignore */
  }
}

export function shouldForceProductTour() {
  if (process.env.REACT_APP_PRODUCT_TOUR === '1') return true;
  if (typeof window === 'undefined') return false;
  try {
    return new URLSearchParams(window.location.search).get('tour') === '1';
  } catch {
    return false;
  }
}

export function getUrlTourStepFilter() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = new URLSearchParams(window.location.search).get('steps');
    if (!raw) return null;
    return raw.split(',').map((s) => s.trim()).filter(Boolean);
  } catch {
    return null;
  }
}
